import classes from './Subfooter.module.scss';


export default function Subfooter(props) {
    
    if (!props) return null;

    const { card_content } = props?.data[0]?.attributes?.get_ayoba[1];

    return (
        <div className={classes.oSubFooter}>
            <div className={`container`}>
                <div className={`row`}>
                    <div className={classes.oSubfooterContainer}>
                        <div className={`${classes.mSubfooterCardBody} fontRTL`}>
                            {/* <Badge text={card_title} theme="grey" width="inline" /> */}
                            <span className={`${classes.aTitle} fnt34`}>
                                {card_content.site_header}
                            </span>
                            <p className={`${classes.aText} fnt16f`}>
                                {card_content.site_description}
                            </p>
                            
                            
                        </div>

                        <div className={classes.downloadLinksContainer}>
                            {/* {pageLoad && (isAndroid || !isMobile) ? (
                                <DownloadLink
                                    device={device_store[0]}
                                    width={`220`}
                                    height={`65`}
                                />
                            ) : null} */}
                            {/* {pageLoad && (isIOS || !isMobile) ? (
                                <DownloadLink
                                    device={device_store[1]}
                                    width={`220`}
                                    height={`65`}
                                />
                            ) : null} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
